import '__common/pixiCanvasFallback';
import { autoDetectRenderer } from 'pixi.js';

// UBuilder-Lite-only renderer. Uses backgroundAlpha: 0 so the CSS-rendered
// grid on the outer div shows through the Pixi canvas. Routed to from
// renderer.ts:setupRenderer when state().app.isUbuilderLite is true; legacy
// editor keeps the original opaque renderer untouched.
export function setupRendererLite(width: number, height: number) {
  const options = {
    width,
    height,
    antialias: true,
    backgroundAlpha: 0,
  };
  try {
    return autoDetectRenderer(options);
  } catch (_) {
    return autoDetectRenderer({ ...options, forceCanvas: true });
  }
}
